/**
 * Marks string as a translation key.
 * This way locale checker will know, that the key is used.
 **/
export function translationKey(key: string) {
    return key;
}
